type ChannelCoordinates = {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

/* http://bboxfinder.com/#54.174322,9.440582,54.174706,9.45203 */
const kiel: ChannelCoordinates = {
  y1: 54.174706,
  x1: 9.440582,
  y2: 54.174322,
  x2: 9.45203,
};

/* http://bboxfinder.com/#9.029144,-79.634665,9.03176,-79.632358 */
const panama: ChannelCoordinates = {
  y1: 9.029144,
  x1: -79.634665,
  y2: 9.03176,
  x2: -79.632358,
};

/* http://bboxfinder.com/#29.95892,32.582319,29.9596,32.586953 */
const suez: ChannelCoordinates = {
  y1: 29.9596,
  x1: 32.582319,
  y2: 29.95892,
  x2: 32.586953,
};

/* http://bboxfinder.com/#-52.744541,-70.294000,-52.634079,-70.280474 */
const magellan_strait: ChannelCoordinates = {
  y1: -52.744541,
  x1: -70.294000,
  y2: -52.634079,
  x2: -70.280474,
}

/* http://bboxfinder.com/#77.548556,102.818685,78.259721,103.335042 */
const bolshevik_strait: ChannelCoordinates = {
  y1: 77.548556,
  x1: 102.818685,
  y2: 78.259721,
  x2: 103.335042,
}

/* http://bboxfinder.com/#68.892725,-115.598406,74.651861,-113.276917 */
const canadian_arctic: ChannelCoordinates = {
  y1: 68.892725,
  x1: -115.598406,
  y2: 74.651861,
  x2: -113.276917,
}

export const channels = {
  kiel,
  panama,
  suez,
  magellan_strait,
  bolshevik_strait,
  canadian_arctic,
};

type ChannelName = keyof typeof channels;

export const channelNames: ChannelName[] = Object.keys(channels) as ChannelName[];

const channelLabelByChannelName: Record<ChannelName, string> = {
  kiel: 'Kiel Canal',
  magellan_strait: 'Strait of Magellan',
  panama: 'Panama Canal',
  suez: 'Suez Canal',
  bolshevik_strait: 'Bolshevik Strait',
  canadian_arctic: 'Canadian Arctic',
}

export function formatChannelName(channelName: string) {
  const label = channelLabelByChannelName[channelName as ChannelName];

  if (!label) {
    console.error(`Unknown channel name encountered ${channelName}`);
    return channelName;
  }

  return label;
}
